import { IS_DEMO_MODE } from '@/utils/demoMode';
import { TimelineComponent } from './Timeline.component';
import { TimelineDemoComponent } from './Timeline.demo.component';

export const TimelinePage = IS_DEMO_MODE
  ? TimelineDemoComponent
  : TimelineComponent;
